import { AnimatePresence, motion } from "motion/react";
import { createStore, useStore } from "../lib/store";

interface ToastItem {
  id: number;
  text: string;
  tone: "info" | "good" | "bad";
}

const toasts = createStore<ToastItem[]>([]);
let seq = 0;

export function toast(text: string, tone: ToastItem["tone"] = "info", ms = 2600) {
  const id = ++seq;
  toasts.set((l) => [...l.slice(-2), { id, text, tone }]);
  setTimeout(() => toasts.set((l) => l.filter((t) => t.id !== id)), ms);
}

export function ToastHost() {
  const list = useStore(toasts);
  return (
    <div className="pointer-events-none fixed inset-x-0 top-[max(12px,env(safe-area-inset-top))] z-[70] flex flex-col items-center gap-2 px-4" aria-live="polite">
      <AnimatePresence>
        {list.map((t) => (
          <motion.div
            key={t.id}
            initial={{ y: -24, opacity: 0, scale: 0.9 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -16, opacity: 0 }}
            transition={{ type: "spring", stiffness: 500, damping: 30 }}
            className="pointer-events-auto max-w-md rounded-full px-5 py-3 text-center font-bold"
            style={{
              background: t.tone === "good" ? "var(--color-good)" : t.tone === "bad" ? "var(--color-candy)" : "var(--color-ink)",
              color: t.tone === "bad" ? "#fff" : "var(--color-ground)",
            }}
          >
            {t.text}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
